import { gql } from '@apollo/client';

export const fetchInvoiceGroupsForSearch = gql`
  query fetchInvoiceGroupsForPPCSearch(
    $searchOptions: ConnectionSearchOptions
    $filterOptions: FilterOption
    $isOrgSearchEnabled: Boolean
    $transactionAccountId: ID!
  ) {
    invoiceGroups(
      searchOptions: $searchOptions
      filterOptions: $filterOptions
      isOrgSearchEnabled: $isOrgSearchEnabled
      transactionAccountId: $transactionAccountId
    ) {
      totalCount
      nodes {
        id
      }
    }
  }
`;
